import isExpired from './isExpired';

import { msalIdTokenKey, piriMsalIdTokenKey, scopes } from './constants';

const checkAndRefreshToken = async (token, $msal) => {
  let newToken = token;

  if (!token || isExpired(token)) {
    const acquiredToken = await $msal.acquireToken({ scopes });

    newToken = acquiredToken?.idToken?.rawIdToken;
  }

  $msal.data.idToken = newToken;

  localStorage.setItem(piriMsalIdTokenKey, newToken);
};

const acquireIdToken = async $msal => {
  try {
    if ($msal?.data?.idToken) {
      localStorage.setItem(piriMsalIdTokenKey, $msal.data.idToken);

      await checkAndRefreshToken($msal?.data?.idToken, $msal);

      return;
    }

    let token = localStorage.getItem(piriMsalIdTokenKey);

    if (!token || token === 'undefined') {
      token = localStorage.getItem(msalIdTokenKey);
    }

    await checkAndRefreshToken(token, $msal);
  } catch (e) {
    console.error(e);
  }
};

export default acquireIdToken;
